import AlertIcon from './AlertIcon';
export default AlertIcon;
//# sourceMappingURL=index.js.map